export function FieldLabel({ children, required }) {
  return (
    <label className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.15em] text-[var(--text-muted)] mb-1.5">
      {children}
      {required && <span className="text-red-400">*</span>}
    </label>
  );
}

export function ColorPicker({ label, value, onChange, testId }) {
  return (
    <div className="bg-[var(--bg-card)] border border-[var(--border)] rounded-xl p-2.5 flex items-center gap-2">
      <input type="color" value={value} onChange={e => onChange(e.target.value)}
        className="w-8 h-8 rounded-lg border-0 cursor-pointer bg-transparent shrink-0 [&::-webkit-color-swatch]:rounded-md [&::-webkit-color-swatch-wrapper]:p-0" data-testid={testId} />
      <div className="min-w-0">
        <span className="block text-[9px] text-[var(--text-muted)] uppercase tracking-wider">{label}</span>
        <input type="text" value={value} onChange={e => { if (/^#[0-9a-fA-F]{0,6}$/.test(e.target.value)) onChange(e.target.value); }}
          className="bg-transparent text-[11px] font-mono text-[var(--text-secondary)] w-full outline-none" data-testid={`${testId}-hex`} />
      </div>
    </div>
  );
}

export function ProviderDot({ provider }) {
  const colors = {
    openai: "bg-emerald-400",
    gemini: "bg-blue-400",
    fal: "bg-amber-400",
  };
  return <span className={`w-2 h-2 rounded-full ${colors[provider] || "bg-gray-400"}`} />;
}
